export class RoutePaths {
    static readonly ROOT = "";
    static readonly HOME = "home";
    static readonly STUDENTS = "students";
    static readonly SUBSCRIPTION = "subscription";
    static readonly LOGIN = "login";
    static readonly SIGNUP = "signup";

    static readonly COMING_SOON = "coming-soon";
    static readonly NOT_FOUND = "**";
}

export default RoutePaths;
